export default __webpack_public_path__ + "static/media/coffee1.582ebaea.jpg";